"use strict";

var _debounce = _interopRequireDefault(require("lodash-es/debounce"));

var _themeSections = require("@shopify/theme-sections");

var _cssClasses = _interopRequireDefault(require("../helpers/cssClasses"));

var _utils = require("../helpers/utils");

var _toggle = _interopRequireDefault(require("../components/toggle"));

var _notification = _interopRequireDefault(require("../components/notification"));

var _scrollDirection = _interopRequireDefault(require("../mixins/scroll-direction"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Section: Site header
 * ------------------------------------------------------------------------------
 * Contains highly coupled scripts to control site header components
 *
 * @namespace siteHeader
 */

/**
 * DOM selectors.
 */


var selectors = {
  container: '[js-site-header="container"]',
  announcementHeader: '#announcement-header'
};
/**
 * Create a new site header object.
 */

(0, _themeSections.register)('site-header', {
  /**
   * Callback function when the section is loaded in via the 'sections.load()' function or by Theme Editor
   * 'shopify:section:unload' event
   */
  onLoad: function onLoad() {
    this.constructComponents();
    this.init();
    this.yotpoPoints();
  },

  /**
   * Component selectors.
   */
  setNodeSelectors: function setNodeSelectors() {
    this.container = document.querySelector(selectors.container);
    this.announcementHeader = document.querySelector(selectors.announcementHeader);
  },

  /**
   * Instantiate search bar toggle.
   */
  constructSearchToggle: function constructSearchToggle() {
    this.SearchBar = (0, _toggle["default"])({
      toggleSelector: 'searchToggle',
      targetSelector: 'searchTarget'
    });
  },

  /**
   * Instantiate announcement component.
   */
  constructAnnouncement: function constructAnnouncement() {
    this.Announcement = (0, _notification["default"])({
      container: '.site-header__announcement',
      enableCookies: true,
      cookie: {
        namespace: 'frame_announcement',
        value: 'dismissed'
      }
    });
  },

  /**
   * Instantiate a collapsed header on scroll using scrollDirection helper.
   */
  constructStickyHeader: function constructStickyHeader() {
    this.AnimatedHeader = (0, _scrollDirection["default"])({
      throttle: 250,
      start: 100
    });
  },

  /**
   * Construct section components.
   */
  constructComponents: function constructComponents() {
    this.constructSearchToggle();
    this.constructAnnouncement();
    this.constructStickyHeader();
  },

  /**
   * Initialise component.
   */
  init: function init() {
    var _this = this;

    this.setNodeSelectors();
    this.Announcement.init();
    this.setScrollEvents();
    this.setSearchToggle();
    this.setStickyHeader();
    window.addEventListener('load', function () {
      _this.updateBodyOffset();

      _this.checkAnnouncementBarActive();
    });
  },

  /**
   * Set search toggle events.
   */
  setSearchToggle: function setSearchToggle() {
    this.SearchBar.init();
  },

  /**
   * Set sticky header events after document has loaded styling.
   */
  setStickyHeader: function setStickyHeader() {
    var _this2 = this;

    this.AnimatedHeader.init();
    this.container.parentNode.classList.add(_cssClasses["default"].sticky);
    this.updateBodyOffset();
    (0, _utils.on)('resize', (0, _debounce["default"])(function () {
      return _this2.handleResizeEvents();
    }, 250));
  },

  /**
   * Add class to body when announcement bar is active
   */
  checkAnnouncementBarActive: function checkAnnouncementBarActive() {
    var announcementBar = document.querySelector('.site-header__announcement');

    if (announcementBar) {
      document.body.classList.add('announcement-bar-active');
    }
  },

  /**
   * Handle resize events by requesting animation frame.
   */
  handleResizeEvents: function handleResizeEvents() {
    this.updateBodyOffset();
  },

  /**
   * Re-calculate body margin-top using current header height.
   */
  updateBodyOffset: function updateBodyOffset() {
    document.body.style.paddingTop = "".concat(this.container.offsetHeight, "px");
  },

  /**
   * Fetch and display Yotpo loyalty points.
   */
  yotpoPoints: function yotpoPoints() {
    var options = {
      method: 'GET',
      headers: {
        Accept: 'application/json'
      }
    };

    if (window.theme.customer) {
      var customerId = window.theme.customer.id;
      var url = "https://loyalty.yotpo.com/api/v2/customers?api_key=n90sNROr8QgVGVDinH6oUAtt&guid=s20DxBtXYxrNRzJ-R49eyw&customer_id=".concat(customerId); // eslint-disable-next-line no-undef

      fetch(url, options).then(function (response) {
        return response.json();
      }).then(function (data) {
        var pointsBalance = data.points_balance;
        var pointsEl = document.querySelector('[js-site-header="loyaltyPoints"]');
        var pointsTextEl = document.querySelector('[js-site-header="loyaltyPointsText"]');
        var mobilePointsEl = document.querySelector('[js-site-header="mobileLoyaltyPoints"]');
        var mobilePointsTextEl = document.querySelector('[js-site-header="mobileLoyaltyPointsText"]');

        if (pointsEl) {
          pointsEl.textContent = pointsBalance;
        }

        if (pointsTextEl) {
          pointsTextEl.textContent = window.theme.strings.loyalty.points;
        }

        if (mobilePointsEl) {
          mobilePointsEl.textContent = pointsBalance;
        }

        if (mobilePointsTextEl) {
          mobilePointsTextEl.textContent = window.theme.strings.loyalty.points;
        }

        return null;
      }) // eslint-disable-next-line no-console
      ["catch"](function (err) {
        return console.error(err);
      });
    }
  },

  /**
   * Set listeners based on scroll direction.
   */
  setListeners: function setListeners() {
    var _this3 = this;

    Frame.EventBus.listen('Notification:dismissed', function () {
      _this3.updateBodyOffset();
    });
    Frame.EventBus.listen('ScrollDirection:down', function () {
      _this3.container.parentNode.classList.add(_cssClasses["default"].collapsed);
    });
    Frame.EventBus.listen('ScrollDirection:top', function () {
      _this3.container.parentNode.classList.remove(_cssClasses["default"].collapsed);
    });
    Frame.EventBus.listen('Toggle:searchTarget:open', function () {
      document.documentElement.classList.add('js-search-active');
    });
    Frame.EventBus.listen('Toggle:searchTarget:close', function () {
      document.documentElement.classList.remove('js-search-active');
    });
  },

  /**
   * Set scroll events for sticky nav.
   */
  setStickyScrollEvent: function setStickyScrollEvent() {
    var _this4 = this;

    var prevScroll = window.scrollY || document.body.scrollTop;
    var threshold = this.container.offsetHeight;

    var scrollHandler = function scrollHandler() {
      var curScroll = window.scrollY || document.body.scrollTop;
      var isScrollDown = curScroll > prevScroll;
      var isBeyondThreshold = curScroll > threshold;
      var parentNode = _this4.container.parentNode;

      if (isScrollDown && isBeyondThreshold) {
        parentNode.classList.add('is-visible');
      } else if (!isScrollDown) {
        parentNode.classList.remove('is-visible');
      }

      if (isBeyondThreshold) {
        parentNode.classList.add('hide-announcement');
      } else {
        parentNode.classList.remove('hide-announcement');
      }

      prevScroll = curScroll;
    };

    window.addEventListener('scroll', scrollHandler);
  },

  /**
   * Set scroll events.
   */
  setScrollEvents: function setScrollEvents() {
    this.setListeners();
    this.setStickyScrollEvent();
  }
});